import 'isomorphic-fetch';
import deepmerge from 'deepmerge';
import { firebaseAuth } from '../firebase';

async function checkStatus(response) {
  if (response.status >= 200 && response.status < 400) {
    return response;
  }

  const err = new Error(response.statusText);
  const parsedResponse = await response.json();
  err.response = parsedResponse;
  err.response.status = response.status;
  throw err;
}

function parseJSON(response) {
  return response
  .json()
  .catch(() => response);
}

export default async function request(url, options = {}, ignoreParse) {
  const token = await firebaseAuth.currentUser.getIdToken();

  const requestOptions = deepmerge({
    credentials: 'same-origin',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  }, options);

  return fetch(url, requestOptions)
    .then(checkStatus)
    .then((response) => {
      if (ignoreParse) {
        return response;
      }
      return parseJSON(response);
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js